import { render, staticRenderFns } from "./consignSettle.vue?vue&type=template&id=84e97166&scoped=true&"
import script from "./consignSettle.vue?vue&type=script&lang=js&"
export * from "./consignSettle.vue?vue&type=script&lang=js&"
import style0 from "./consignSettle.vue?vue&type=style&index=0&id=84e97166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e97166",
  null
  
)

export default component.exports